import React, { useMemo, useEffect, useState, useCallback } from 'react';
import block from 'bem-cn';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Spinner from 'components/Spinner';
import Paginator from 'components/Paginator/desktop';
import useWithdrawalRequests from 'features/withdrawal/helpers/useWithdrawalRequests';
import { itemsOnPage } from 'features/withdrawal/helpers/data';

import WithdrawalCard from './WithdrawalCard/WithdrawalCard';
import WithdrawalHistoryItem from './WithdrawalHistoryItem';
import WithdrawalFilter from './WithdrawalFilter';

import './Withdrawal.scss';

const b = block('withdrawal-desktop');

const Withdrawal = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { actionProcessing } = useSelector(state => state.slotsBetHistory, shallowEqual);

  const filterData = useWithdrawalRequests();
  const { items, state, pageCount, write, onSubmit } = filterData;
  const { page } = state;

  const [selectedCard, setSelectedCard] = useState(null);

  const itemsElements = useMemo(
    () =>
      items.map(t => (
        <div key={t.key} className={b('item')}>
          <WithdrawalHistoryItem card={t} setSelectedCard={setSelectedCard} />
        </div>
      )),
    [items],
  );

  return (
    <div className={b()}>
      {selectedCard !== null && (
        <div className={b('modal')}>
          <WithdrawalCard card={selectedCard} closeFunction={() => setSelectedCard(null)} callback={onSubmit} />
        </div>
      )}
      <Spinner isLoading={actionProcessing} />
      <h3 className={b('title')}>{locale.withdrawalRequests[1]}</h3>
      <div className={b('content')}>
        <div className={b('filters')}>
          <WithdrawalFilter filterData={filterData} />
        </div>
        <div className={b('list')}>{itemsElements}</div>
        <div className={b('paginator-container')}>
          <div className={b('paginator')}>
            <Paginator count={pageCount} currentPage={page} onPageClick={value => write(value, 'page')} />
          </div>
        </div>
      </div>
    </div>
  );
};

Withdrawal.propTypes = {};

export default Withdrawal;
